import React, { useCallback, useEffect } from "react";
import { Medicine } from "../utils/types";
import {
  ANSWER_FEEDBACK_DURATION,
  MEDICINE_INTRO_DURATION,
} from "../utils/constants";
import MedicineViewIntro from "./MedicineIntro";
import useKeysPress from "../hooks/useKeysPress";
import { QuestionView } from "./Question";

function MedicineView({
  medicine,
  onMedicineQuestionsEnd,
}: {
  medicine: Medicine;
  onMedicineQuestionsEnd: Function;
}) {
  const [isIntroShown, setIsIntroShown] = React.useState(false);
  const [activeQuestionIndex, setActiveQuestionIndex] = React.useState(0);

  useEffect(() => {
    let timeout: any;
    if (!isIntroShown) {
      timeout = setTimeout(() => {
        setIsIntroShown(true);
      }, MEDICINE_INTRO_DURATION);
    }
    return () => {
      timeout && clearTimeout(timeout);
    };
  }, [isIntroShown]);

  const ResetData = useCallback(() => {
    setActiveQuestionIndex(0);
    setIsIntroShown(false);
  }, [activeQuestionIndex, isIntroShown]);

  const goToNextQuestion = useCallback(() => {
    // setTimeout(() => {
    if (activeQuestionIndex < medicine.questions.length - 1) {
      setActiveQuestionIndex(activeQuestionIndex + 1);
    } else {
      onMedicineQuestionsEnd();
      ResetData();
    }
    // }, ANSWER_FEEDBACK_DURATION);
  }, [activeQuestionIndex]);

  return (
    <section className={`medicine-container ${medicine.className}`}>
      <MedicineViewIntro
        visible={!isIntroShown}
        image={medicine.logo}
        message={medicine.intro}
      />

      <header>
        <img src={`/assets/${medicine.logo}`} alt="medicine logo " />
      </header>

      <QuestionView
        question={medicine.questions[activeQuestionIndex]}
        onQuestionEnd={goToNextQuestion}
      />
    </section>
  );
}

export default MedicineView;
